// i18n area 'common' — locale da-DK (task #171, onda 2): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/common.da-DK.meta.json.
import type { enUS } from './common'

export const daDK: typeof enUS = {
  nav: {
    home: 'Hjem',
    vms: 'Virtuelle maskiner',
    templates: 'Templates',
    importVms: 'Importer VM',
    containers: 'Containere',
    containersApps: 'Apps',
    containersPods: 'Pods',
    containersCt: 'CT',
    multiscsi: 'TVStor MultiSCSI',
    containersOciImages: 'OCI-images',
    containersOciRegistries: 'OCI-registries',
    containersCtTemplates: 'CT-templates',
    networkServices: 'Netværkstjenester',
    firewall: 'Firewall',
    checkpoints: 'Checkpoints',
    backup: 'Backup',
    monitoring: 'Overvågning',
    cluster: 'Cluster',
    clusterSettings: 'Globale indstillinger',
    clusterNodes: 'Noder',
    clusterDevices: 'USB- og PCIe-ressourcer',
    clusterFederation: 'Federation',
    network: 'Netværk',
    overlayNetworks: 'Overlay-netværk',
    fabric: 'Fabric',
    ipam: 'IPAM',
    storage: 'Storage',
    data: 'Data',
    storages: 'Storage',
    hci: 'Hyperkonvergens',
    ceph: 'Ceph',
    system: 'System',
    tasks: 'Tasks',
    events: 'Hændelser',
    audit: 'Audit',
    diagnostics: 'Diagnostik',
    notifications: 'Notifikationer',
    proximity: 'TVirt Proximity',
    users: 'Brugere og grupper',
    groups: 'Grupper',
    mfa: 'MFA',
    realms: 'Realms og SSO',
    rbac: 'Roller og tilladelser',
    credentials: 'Credentials',
    scopes: 'Scopes',
    tags: 'Tags',
    explorer: 'Udforsk',
    licensing: 'Licens',
    information: 'Information'
  },
  mode: {
    light: 'Lys',
    dark: 'Mørk',
    system: 'System',
    tooltip: 'Tema'
  },
  language: {
    tooltip: 'Sprog'
  },
  langRegion: {
    europe: 'Europa',
    northAmerica: 'Nordamerika',
    southAmerica: 'Sydamerika',
    asia: 'Asien'
  },
  notFound: {
    title: 'Siden blev ikke fundet',
    body: 'Denne adresse svarer ikke til nogen side i TVirt — den kan være flyttet med en opdatering, eller linket er gammelt.',
    backHome: 'Tilbage til Hjem'
  },
  scopeBrowser: {
    title: 'Scope',
    all: 'Hele clusteret',
    noChildren: 'Intet under-scope her',
    recursive: 'Medtag underliggende',
    collapse: 'Sammenfold scope-panelet',
    openPicker: 'Udforsk scopes',
    up: 'Gå et niveau op',
    countTooltip: '{direct} i dette scope · {total} med underliggende'
  },
  search: {
    tooltip: 'Søg (⌘K)',
    placeholder: 'Søg VM, netværk, storage…',
    empty: 'Ingen resultater',
    groups: {
      recent: 'Seneste',
      shortcuts: 'Genveje',
      actions: 'Handlinger',
      goTo: 'Gå til'
    },
    kind: {
      catalog: 'Katalog',
      scope: 'Scope',
      node: 'Node'
    },
    footer: {
      navigate: 'naviger',
      open: 'åbn',
      close: 'luk'
    },
    actions: {
      createVm: 'Opret VM…',
      uploadIso: 'Upload ISO…',
      clusterSettings: 'Cluster-indstillinger',
      consoleOf: 'Gå til konsollen for {name}'
    }
  },
  stub: {
    containersSummary: 'Applikationer og systemcontainere (CT), med deres OCI-images, registries og templates — håndteret side om side med dine VM.',
    sectionSummary_vms: 'Virtuelle maskiner og deres templates — livscyklus, snapshots, migrering og konsol.',
    sectionSummary_storages: 'De storage-pools, hvor VM-diske, images og metadata bor.',
    sectionSummary_catalogs: 'Hjemmet for clusterets fil-artefakter: ISO-images, CT- og VM-templates og OCI-arkiver, organiseret i kataloger.',
    sectionSummary_overlay: 'VXLAN-overlay-netværk mellem clusterets noder.',
    sectionSummary_fabric: 'Inventaret over det fysiske netværk — switche, porte, LAGG og logiske netværk.',
    sectionSummary_ipam: 'Adresseringen afledt af fabric- og overlay-netværkene: hvem der holder hver adresse.',
    sectionSummary_services: 'DHCP- og DNS-servere afledt af netværksregistret.',
    sectionSummary_ceph: 'Håndterede Ceph-clustre på TVirt-noderne.',
    sectionSummary_hci: 'De hyperkonvergerede storage-teknologier på TVirt-noderne.',
    sectionSummary_cluster: 'Noder, medlemskab og cluster-indstillinger.',
    containers: 'Systemcontainere er på roadmappen — denne sektion kommer til at huse dem.',
    containersApps: 'Containeriserede applikationer er på roadmappen — dette område kommer til at huse dem.',
    containersPods: 'Pods samler containere, der deler netværk og volumener — instanserne er apps.',
    containersCt: 'Systemcontainere (CT) er på roadmappen — dette område kommer til at huse dem.',
    multiscsi: 'TVStor MultiSCSI er på roadmappen — dette område kommer til at huse den.',
    clusterFederation: 'Federation mellem TVirt-clustre er på roadmappen — dette område kommer til at huse den.',
    containersOciImages: 'OCI-images er på roadmappen — dette område kommer til at huse dem.',
    containersOciRegistries: 'OCI-registries er på roadmappen — dette område kommer til at huse dem.',
    containersCtTemplates: 'CT-templates er på roadmappen — dette område kommer til at huse dem.',
    importVms: 'ESXi- og Proxmox-importerne lander her: konvertering af guests og massemigrering ind i TVirt.',
    backup: 'Den indbyggede backup kommer med 6.2: content-addressed deduplikerede repositories, CBT-inkrementaler, immutabilitetsvinduer og repo-to-repo-replikering.',
    monitoring: 'De cluster-dækkende contention-dashboards (cpu.ready, PSI-pres, indbyggede alerts) er på vej — i dag bor de samme metrikker i hver VMs detaljer.'
  },
  home: {
    welcome: 'Du er logget ind som: {name}',
    subtitle: 'Her er dit TVirt-cluster med ét blik.',
    loadError: 'Kunne ikke indlæse oversigten — kan TVirt-backenden nås?',
    health: {
      ok: 'Alt i orden',
      warning: 'Opmærksomhed',
      critical: 'Kritiske problemer'
    },
    reason: {
      'node-down': '{subject} er slukket',
      'node-stale': '{subject} har ikke ladet høre fra sig et stykke tid',
      'node-maintenance': '{subject} i vedligeholdelse',
      'tasks-failed': {
        one: '{n} fejlet task de seneste 24 timer',
        other: '{n} fejlede tasks de seneste 24 timer'
      },
      'storage-degraded': 'storagen {subject} er degraderet',
      'storage-error': 'storagen {subject} er i fejl',
      'ceph-warning': 'Ceph {subject}: HEALTH_WARN',
      'ceph-error': 'Ceph {subject}: HEALTH_ERR',
      'store-unreachable': 'clusterets store kan ikke nås',
      'license-absent': 'ingen licens — nye VM kan ikke starte',
      'license-expired': 'licensen er udløbet — nye VM kan ikke starte',
      'license-exceeded': 'licensgrænsen er overskredet — nye VM kan ikke starte',
      'failover-reserve-eroded': 'failover-reserven er næsten opbrugt',
      'failover-reserve-exhausted': 'failover-reserven er opbrugt — nye VM kan ikke starte',

      'oci-cache-nearly-full': 'OCI-cachen på {subject} er næsten fuld — digests fjernes i hånden',
      'oci-cache-full': 'OCI-cachen på {subject} er fuld — ingen pull lykkes, før digests fjernes',
      'config-replica-empty': 'konfigurationsreplikaen på {subject} er TOM — noden har ingen klyngekonfiguration, før en replikering lykkes',
      'config-replica-stalled': 'konfigurationsreplikering på {subject} står stille — den lokale kopi halter efter klyngens konfiguration'
    },
    staleChip: 'Data ikke opdateret',
    staleAsOf: 'seneste replika {time}',
    zone: {
      nodes: 'Noder',
      failoverReserve: 'Failover-reserve',
      capacity: 'Kapacitet',
      workload: 'Arbejdslast',
      protection: 'Beskyttelse',
      activity: 'Seneste aktivitet'
    },
    reserve: {
      state: {
        ok: 'Reserven er intakt',
        eroded: 'Reserven er næsten opbrugt',
        exhausted: 'Reserven er opbrugt',
        unknown: 'Reserven er ukendt'
      },
      tolerate: {
        one: 'tolererer tab af {n} node',
        other: 'tolererer tab af {n} noder'
      },
      usedOf: '{used} / {allowed} GiB i brug',
      keepFree: '{n} GiB holdt fri til failover',
      expendable: 'heraf {n} som kan ofres i drift',
      headroom: 'der kan stadig startes {n} GiB',
      short: 'reserven mangler {n} GiB — nye VM kan ikke starte',
      hp: {
        usedOf: 'Sider på {size} — i brug: {used} / {allowed}',
        keepFree: 'holdt fri til failover: {keep}',
        headroom: 'kan stadig startes: {n}',
        short: 'mangler i reserven: {n} — nye VM med enorme sider kan ikke starte'
      },
      worstCase: 'værste fald: {nodes}',
      unavailable: '{node}: {reason}',
      unknown: 'Ingen node har endnu erklæret sin hukommelse — reserven kan ikke beregnes, og ingen start afvises.',
      reason: {
        attestedDown: 'attesteret slukket',
        maintenance: 'i vedligeholdelse',
        unreachable: 'kan ikke nås',
        capacityUnknown: 'hukommelse ikke erklæret'
      }
    },
    node: {
      cpu: '{n} CPU',
      cpuTopology: '{cores} kerner / {threads} tråde',
      memUsedOf: '{used} / {total} GiB',
      activeVms: {
        one: '{n} aktiv VM',
        other: '{n} aktive VM'
      },
      activeVmsUnknown: 'aktive VM ukendt',
      lastSeen: 'set {time}',
      neverSeen: 'aldrig set',
      down: 'Slukket',
      maintenance: 'Vedligeholdelse',
      stale: 'Kan ikke nås'
    },
    capacity: {
      usedOf: '{used} / {total} GiB',
      provisioned: '{n} GiB provisioneret',
      reserve: 'reserve {n} GiB',
      unobserved: 'kapacitet endnu ikke observeret',
      empty: 'Ingen storage endnu'
    },
    workload: {
      vms: 'Virtuelle maskiner',
      apps: 'Apps',
      services: 'Netværkstjenester',
      empty: 'Endnu ingen',
      phasesUnknown: 'fordeling pr. fase ikke tilgængelig'
    },
    protection: {
      none: 'Ingen backup-destination konfigureret — beskyt din konfiguration.',
      configure: 'Konfigurer checkpoints',
      noRuns: 'Intet checkpoint er oprettet endnu.',
      last: 'Seneste checkpoint',
      onTarget: 'på {target}',
      viewAll: 'Checkpoints'
    },
    activity: {
      empty: 'Ingen nylig aktivitet',
      failed24: {
        one: '{n} fejlet på 24 timer',
        other: '{n} fejlede på 24 timer'
      },
      viewAll: 'Se alle tasks'
    }
  },
  notes: {
    title: 'Noter',
    tabEdit: 'Rediger',
    tabPreview: 'Forhåndsvisning',
    placeholder: 'Operatørens frie noter — Markdown renderes i forhåndsvisningen',
    empty: 'Ingen noter',
    tooLarge: 'Noterne overskrider grænsen på 64 KiB',
    saveError: 'Kunne ikke gemme noterne'
  },
  common: {

    // Round «errori onesti» (2026-08-03): una risposta 200 che questo client
    // non sa leggere NON è una rete giù — accusare il backend manda
    // l'operatore a guardare un servizio che funziona (bug hunt #157, U1).
    contractError: 'Backendets svar indeholder en værdi, som denne grænseflade ikke kender: {field}={value} — opdatér webgrænsefladen til backendets version.',
    contractErrorItems: '{count} objekter på denne liste kan denne grænseflade ikke læse ({field}={value}), og de vises ikke.',
    staleHint: 'Storen kan ikke nås — dette er denne nodes config-replika; flådens tilstand er ukendt.',
    staleStateAge: 'tilstand pr. {time}',
    staleStateNever: 'tilstanden er aldrig modtaget fra storen: du ser kun denne nodes egne observationer',
    staleStateTooltip: 'Klyngens store kan ikke nås: den observerede tilstand (fase, node, agent) kommer fra denne nodes tilstandsreplika og stammer fra den seneste vellykkede læsning fra storen — den kan være forældet.',
    noPermission: 'Du har ikke tilladelse til denne handling',
    actionStillRunning: 'Handlingen er stadig i gang — resultatet kendes endnu ikke',
    staleWrite: 'En anden har ændret dette objekt, mens du redigerede det — intet blev skrevet. Genindlæs og gentag din ændring på den aktuelle tilstand.',
    staleReload: 'Genindlæs',
    preview: 'Forhåndsvisning',
    previewTitle: 'Forhåndsvisning af resultatet',
    previewNothingWritten: 'Simuleret på serveren — intet blev skrevet.',
    previewChanged: 'Fremhævet: de værdier, der ville ændre sig.'
  },
  context: {
    copySelection: 'Kopier markeret tekst'
  },
  crud: {
    create: 'Opret',
    viewDetails: 'Vis detaljer',
    viewOrEdit: 'Vis eller rediger',
    selected: 'valgt',
    viewUsingVms: 'Vis VM, der bruger ressourcen',
    clearSelection: 'Fravælg',
    deleteSelected: 'Slet valgte',
    bulkConfirmBody: {
      one: 'Slette {count} valgt element? Hvis det er beskyttet, rapporteres det og beholdes.',
      other: 'Slette de {count} valgte elementer? De beskyttede rapporteres og beholdes.'
    },
    bulkDeleted: 'slettet',
    bulkRefused: 'afvist',
    fieldId: 'ID',
    createdAt: 'Oprettet',
    updatedAt: 'Opdateret',
    immutableField: 'Fastlagt ved oprettelsen — contracten tillader ikke, at det ændres',
    immutableScope: 'Scopet tildeles ved oprettelsen; nogle ressourcer flyttes med en dedikeret handling',
    observedField: 'Observeret tilstand — rapporteret af platformen, kan ikke redigeres'
  }
}
